import React from 'react';
import IconButton from '../../Buttons/IconButton/IconButton';
import { TString } from '../../Response/Utils';
import SuggestionChips from '../../Response/SuggestionChips';
interface Props {
	hideMenu?: Function;
	persistantMenuData?: [];
	voiceResponse: boolean;
	isShowSameItemsMenuEnabled: string;
	changeInput: Function;
	changeScreen: Function;
	submitchanges: Function;
}

function PersistanceMenu(props: Props) {
	let persData: any = props.persistantMenuData;
	return (
		// <div className="persis-menu-block body-text-1">
		//   <div className="close-icon">
		//     <div onClick={() => props.hideMenu()}>
		//       <IconButton
		//         size={'normal'}
		//         title={TString({ labelName: 'closeLabel' })}
		//         image={'close'}
		//         variant={'filled'}
		//       />
		//     </div>
		//   </div>
		//   <div className="persis-list">
		//     <div className="showMenu styled-scroll">
		//       <SuggestionChips
		//         data={persData}
		//         isUser={true}
		//         voiceResponse={props.voiceResponse}
		//         hideMenu={() => props.hideMenu()}
		//       />
		//     </div>
		//   </div>

		//   <div className="tail-div">
		//     <div className="arrow-right"></div>
		//   </div>
		// </div>
		<div className='ff-persistent-menu'>
			<div className='menuwrapper'>
				{persData.map((data) => (
					<>
						<p
							className='ff-chatbot-body1'
							onClick={() => {
								if (data.linkValue) {
									props.submitchanges(data.linkValue);
								}
							}}
						>
							{data.linkText}
						</p>
					</>
				))}
			</div>
		</div>
	);
}

export default PersistanceMenu;
